import React from 'react';
import Moment from 'moment';

import { connect } from 'react-redux';
import api from '../../../../store/api/api';
import { cloneDeep } from 'lodash';

import NavBaseTemplate from '../../../templates/NavBaseTemplate';
import DashTabs from '../../menus/DashTabs';
import FromToDatePickerInput from '../../forms/FromToDatePickerInput';
import DashboardOfficeSelector from '../selectors/DashboardOfficeSelector';
import ScriptSelector from '../selectors/ScriptSelector';
import { setDashboardParams } from '../../../../store/actions';
import FeedbackTile from '../../modals/FeedbackTile';
import {
  pullCampaignOffices,
  pullCampaignScripts,
  updateCampaignAggregates,
} from '../../../../store/api/calls';
import DataTable from '../../tables/DataTable';

class ScriptResponseScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      showSelectionModal: !props.dashboardParams.selectedScript,
      data: [],
    };

    this.SUBMIT_DATE_FORMAT = 'YYYY-MM-DD';
  }

  componentDidMount() {
    this.setState({ loading: true, error: false });
    this.props.setDashboardParams({ selectedOffice: 0 });
    let promises = [pullCampaignScripts(), pullCampaignOffices()];

    Promise.all(promises)
      .then(() => {
        if (
          !this.props.dashboardParams.selectedScript
          // !this.props.scripts
          //   .map((d) => d.id)
          //   .includes(this.props.dashboardParams.selectedScript)
          // true
        ) {
          console.log('no script selected', this.props.scripts[0].id);
          this.props.setSelectedScript(this.props.scripts[0].id);
        } else {
          console.log('script selected', this.props.dashboardParams.selectedScript);
          return this.pullScriptData();
        }
      })
      .catch((err) => {
        console.error('Script Load Failure', err);
        this.setState({ error: true });
      })
      .then(() => {
        this.setState({ loading: false });
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.focusedCampaign !== this.props.focusedCampaign) {
      this.setState({ loading: true, error: false });
      pullCampaignScripts().then(() => {
        this._updateCampaignAggregates();
        this.props.setDashboardParams({
          selectedOffice: 0,
          selectedScript: this.props.scripts[0].id,
        });
        this.pullScriptData().then(() => this.setState({ loading: false }));
      });
    }

    // we don't need to pull again on office so remove from comparison
    let prevParams = prevProps.dashboardParams;
    let currParams = this.props.dashboardParams;
    if (
      (prevParams.start !== currParams.start ||
        prevParams.end !== currParams.end ||
        prevParams.selectedScript !== currParams.selectedScript) &&
      this.props.dashboardParams.selectedScript
    ) {
      this.setState({ loading: true });
      this.pullScriptData().then(() => this.setState({ loading: false }));
    }
  }

  handleDateChange = (start, end) => {
    this.props.setDashboardParams({
      start: start.getTime(),
      end: end.getTime(),
    });
  };

  _updateCampaignAggregates = () => {
    return updateCampaignAggregates(
      Moment(this.props.dashboardParams.start).format(this.SUBMIT_DATE_FORMAT),
      Moment(this.props.dashboardParams.end).format(this.SUBMIT_DATE_FORMAT)
    );
  };

  pullScriptData = (script_id) => {
    this.setState({ error: false });

    const requestDateFormat = 'YYYY-MM-DD';

    let params = {};

    params.start = new Moment(this.props.dashboardParams.start).format(requestDateFormat);
    params.end = new Moment(this.props.dashboardParams.end).format(requestDateFormat);
    params.office = this.props.dashboardParams.selectedOffice
      ? this.props.dashboardParams.selectedOffice
      : null;
    // params.canvasser = this.props.dashboardParams.selectedCanvasser
    //   ? this.props.dashboardParams.selectedCanvasser
    //   : null;
    params.script_id = script_id || this.props.dashboardParams.selectedScript;

    return api
      .get('/script-data/', params)
      .then((res) => {
        this.setState({
          data: [...res.data, ...this.buildCampaignElements(res.data)],
        }); //    , ...this.buildCampaignElements(res.data)
        // this.props.setDashboardParams({refresh: this.props.dashboardParams.refresh ? 0 : 1})
      })
      .catch((err) => {
        this.setState({ error: true });
        console.error(err);
      });
  };

  buildCampaignElements = (data) => {
    // we get one element per question/office. So we treat campaign as an office and add that here too, with the responses correctly summed.

    if (!data || !Array.isArray(data)) return [];

    let scriptelem_hashes = [...new Set(data.map((d) => d.el_hash))];
    let campaign_elems = [];
    scriptelem_hashes.forEach((hash) => {
      const elems = data.filter((d) => d.el_hash === hash);
      let total_responses = 0;

      //create a total responses count, as well as an array that contains all reponses across
      //the different offices so that they are all represented

      let all_responses = [];

      elems.forEach((e) => {
        total_responses += e.total_responses; // || 0;
        (e.responses || []).forEach((r) => {
          if (!all_responses.map((_r) => _r.response).includes(r.response)) {
            all_responses.push(r);
          }
        });
      });
      if (!elems.length) return;
      const elem = cloneDeep(elems[0]);
      elem.responses = all_responses;

      elem.office_id = 0; // 0 is the campaign office placeholder
      elem.total_responses = total_responses;

      (elem.responses || []).forEach((r) => {
        ///some other values
        let response_sum = 0;
        elems.forEach((e) => {
          let resp = e.responses.find((_r) => _r.response === r.response);
          if (resp) response_sum += resp.count;
        });

        r.count = response_sum;
      });

      elem.responses.sort((a, b) => (a.count > b.count ? -1 : 1));

      campaign_elems.push(elem);
    });

    return campaign_elems;
  };

  renderScriptDisplay = () => {
    const filteredScript = this.state.data
      .filter((d) => d.total_responses && d.office_id === this.props.dashboardParams.selectedOffice)
      .sort((a, b) => (a.total_responses > b.total_responses ? -1 : 1));
    // const total_responses = Math.max(...filteredScript.map(d => d.total_responses))

    // if (!filteredScript.length) {
    //   this.setState({data: []})
    //   return;
    // }

    console.log('FILTERED SCRIPT', filteredScript);

    return filteredScript.map((d) => {
      const tableData = (d.responses || []).map((rd) => {
        const response_count = rd.count;
        return {
          response: !isNaN(+rd.response) ? +rd.response : rd.response,
          count: response_count,
          'Percent Total': ((response_count / d.total_responses) * 100).toFixed(2) + '%',
        };
      });

      return (
        <DataTable
          noFilter
          key={d.id}
          data={tableData}
          title={`${d.display_name}`}
          customSubHeader={
            <div className={'mb-4 ml-5'}>
              <div className={'is-size-4'} style={{ fontWeight: 'bold' }}>
                {d.total_responses} responses
              </div>
              <div className={'is-size-4 mt-2'}>{d.prompt}</div>
            </div>
          }
        />
      );
    });
  };

  render() {
    return (
      <NavBaseTemplate location={this.props.location} showAdmin={this.props.is_admin}>
        <DashTabs />
        <h3 className={'primary-text'}>Responses</h3>
        <div className="button-table-top-wrapper">
          <FromToDatePickerInput
            handleDateChange={this.handleDateChange}
            from={new Date(this.props.dashboardParams.start)}
            to={new Date(this.props.dashboardParams.end)}
          />

          <DashboardOfficeSelector />
          <ScriptSelector />
          {/* <DashboardCanvasserSelector /> */}
        </div>

        <div className="results-display-wrapper">
          {!!this.state.data.length ? (
            this.renderScriptDisplay()
          ) : (
            <div className={'card wox-card mt-4'}>
              <h6 className={'secondary-milligram-text'}>No data to display yet.</h6>
            </div>
          )}
        </div>
        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk fa-spin" style={{ marginRight: '15px' }} />
              Loading...
            </div>
          }
          visible={this.state.loading}
        />

        <FeedbackTile
          text={
            <div>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: '15px' }} />
              There was a server error.
            </div>
          }
          visible={this.state.error}
          classNames={'danger'}
        />

        {/*  Script selection modal for if no script is selected on load  */}
        {/* <ScriptSelectionModal */}
        {/*   open={this.state.showSelectionModal} */}
        {/*   onClose={() => this.setState({ showSelectionModal: false })} */}
        {/*   afterSelect={(script_id) => { */}
        {/*     this.setState({ showSelectionModal: false }); */}
        {/*     this.pullScriptData(script_id); */}
        {/*   }} */}
        {/* /> */}
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  aggregates: state.aggregates.data,
  aggregates_loading: state.aggregates.loading,
  aggregates_error: state.aggregates.error,
  is_admin: state.permissions.is_admin,
  dashboardParams: state.dashboardParams,
  focusedCampaign: state.session.focusedCampaign,
  scripts: state.scripts.data,
});

const mapDispatchToProps = (dispatch) => ({
  setDashboardParams: (data) => dispatch(setDashboardParams(data)),
  setSelectedScript: (id) => dispatch(setDashboardParams({ selectedScript: id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScriptResponseScreen);
